import { render } from "./App.vue?vue&type=template&id=38b3be27"
const script = {}

import "./App.vue?vue&type=style&index=0&id=38b3be27&lang=css"

import exportComponent from "/data/jenkins/workspace/jet/cbt/production/deploy-cbt/exam/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__